import React from "react";
import Product from "../../components/Product";

const ProductPage = () => {
  return (
      <Product />
  );
};

export default ProductPage;